export default "__VITE_ASSET__CI8yh1CW__"